export class ResetPasswordRequestModel {
    verificationType: string;
    verificationValue: string;
    newPassword: string;
    email: string;
}
export class UpdatePasswordRequest {
    email: string;
    verificationType: string;
    verificationValue: string;
    newPassword: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/login/ResetPasswordRequestModel.ts